import { createFileRoute } from "@tanstack/react-router";
import Page from "lib/components/layout/Page";
import useShowroomPlanData from "lib/components/showroom2/data/useShowroomPlanData";
import { procurePath, useAppRouterParams } from "lib/routeHelpers";
import cx from "ui/cx";
import SplitFlex from "ui/layouts/SplitFlex";
import styles from "./index.module.scss";

export const SHEETS_DEFAULT_PAGE = "FIRST FLOOR PLAN";

function SingleScreenSplitPage() {
  const planData = useShowroomPlanData();
  const { builderId, planType = "community_plans", planId } = useAppRouterParams();
  const studioDocId = planData?.masterPlan?.studioDocId;
  const communityPlanId = planType === "community_plans" ? planData?.communityPlan?.id : "";
  return (
    <Page pageTitle="Connected Expeirence Demo" className={styles.singlescreen} loading={!studioDocId || !builderId}>
      <SplitFlex className={styles.split} sizeRatio={0.3} firstMinSize={400} canResize={false}>
        {/* Loading in an iframe is required to trigger responsive layout - though it will mean the api route gets called twice here */}
        <iframe
          src={`/demo/showroom?builderId=${builderId}&planType=${planType}&planId=${planId}`}
          width="100%"
          height="100%"
        />
        <SplitFlex direction="vertical" className={cx(styles.split, styles.verticalSplit)} canResize={false}>
          <iframe src={procurePath({ studioDocId, builderId, communityPlanId })} width="100%" height="100%" />
          <iframe
            src={`/demo/sheets?builderId=${builderId}&planType=${planType}&planId=${planId}&page=${encodeURIComponent(
              SHEETS_DEFAULT_PAGE,
            )}`}
            width="100%"
            height="100%"
          />
        </SplitFlex>
      </SplitFlex>
    </Page>
  );
}

export const Route = createFileRoute("/demo/connected/singlescreen")({
  component: SingleScreenSplitPage,
  staticData: { isPublicPage: true },
});
